function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.77,
    height: 9.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5583333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 4.675,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.35,
    width: 18.77,
    height: 9.41,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 14.055,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.76,
    width: 18.77,
    height: 10.91,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 24.215000000000003,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.67,
    width: 18.77,
    height: 11.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.258888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 35.335,
    fontFamily: "Arial"
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41,
    width: 18.77,
    height: 11.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6214285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 46.675,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 52.35,
    width: 18.77,
    height: 11.57,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 58.135000000000005,
    fontFamily: "Arial"
  }, "\n        Gallatin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.92,
    width: 18.77,
    height: 11.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.368
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 69.84,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 75.76,
    width: 18.77,
    height: 11.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7128571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 81.75500000000001,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 87.76,
    width: 18.77,
    height: 12.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 93.995,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100.23,
    width: 18.77,
    height: 14.56,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 107.51,
    fontFamily: "Arial"
  }, "\n        Edwards\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.8,
    width: 18.77,
    height: 14.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 122.13499999999999,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 129.46,
    width: 18.77,
    height: 15.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7533333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 137.35,
    fontFamily: "Arial"
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.24,
    width: 18.77,
    height: 16.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 153.69,
    fontFamily: "Arial"
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.14,
    width: 18.77,
    height: 18.67,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.33375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 171.475,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.81,
    width: 18.77,
    height: 23,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 192.31,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.82,
    width: 18.77,
    height: 24.13,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 215.885,
    fontFamily: "Arial"
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 227.94,
    width: 18.77,
    height: 24.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 240.04,
    fontFamily: "Arial"
  }, "\n        Wabash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.14,
    width: 18.77,
    height: 25.23,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.877
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 264.755,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.37,
    width: 18.77,
    height: 26.94,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 290.84000000000003,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.31,
    width: 18.77,
    height: 27.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.34625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 318.015,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 331.72,
    width: 18.77,
    height: 27.74,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.34625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 345.59000000000003,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.46,
    width: 18.77,
    height: 27.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6814285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 373.385,
    fontFamily: "Arial"
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.31,
    width: 18.77,
    height: 29.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.34625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 401.9,
    fontFamily: "Arial"
  }, "\n        Moultrie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 416.49,
    width: 18.77,
    height: 29.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.754
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 431.125,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 445.76,
    width: 18.77,
    height: 29.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 460.5,
    fontFamily: "Arial"
  }, "\n        Massac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 475.24,
    width: 18.77,
    height: 29.79,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 490.135,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 505.03,
    width: 18.77,
    height: 29.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 520.02,
    fontFamily: "Arial"
  }, "\n        Menard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 535.01,
    width: 18.77,
    height: 30.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 550.05,
    fontFamily: "Arial"
  }, "\n        Ford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 565.09,
    width: 18.77,
    height: 32.11,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.754
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 581.145,
    fontFamily: "Arial"
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 597.2,
    width: 18.77,
    height: 34.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.877
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 614.2950000000001,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 631.39,
    width: 18.77,
    height: 34.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 648.5,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 665.61,
    width: 18.77,
    height: 34.39,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.385,
    y: 682.8050000000001,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 0,
    width: 22.01,
    height: 29.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1442857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.775,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.78,
    y: 0,
    width: 22.01,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6683333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.785000000000004,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        DeWitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.79,
    y: 0,
    width: 22.12,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.85,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.9,
    y: 0,
    width: 22.34,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.07000000000001,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Bond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.24,
    y: 0,
    width: 22.48,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.496
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.47999999999999,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Edgar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.72,
    y: 0,
    width: 22.92,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5840000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.18,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.64,
    y: 0,
    width: 23.28,
    height: 29.61,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.656000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.27999999999997,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.92,
    y: 0,
    width: 23.97,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.424285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.90499999999997,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.88,
    y: 0,
    width: 24.37,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8740000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.065,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.26,
    y: 0,
    width: 24.39,
    height: 29.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.45499999999998,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.65,
    y: 0,
    width: 25.74,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.677142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.52,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.39,
    y: 0,
    width: 25.85,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.23125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.315,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.24,
    y: 0,
    width: 26.94,
    height: 29.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.388
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.71000000000004,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Piatt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.18,
    y: 0,
    width: 27.57,
    height: 29.61,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9385714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.96500000000003,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.76,
    y: 0,
    width: 27.57,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.514
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.545,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.33,
    y: 0,
    width: 30.35,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.505,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Saline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.68,
    y: 0,
    width: 32.74,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.05,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Jersey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.42,
    y: 0,
    width: 33.18,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.01,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.6,
    y: 0,
    width: 33.7,
    height: 29.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.45000000000005,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        McDonough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.3,
    y: 0,
    width: 34.27,
    height: 29.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.961
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.435,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Jo_Daviess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.57,
    y: 0,
    width: 36.46,
    height: 29.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.922
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.8000000000001,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.04,
    y: 0,
    width: 37.65,
    height: 29.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.961
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.865,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.69,
    y: 0,
    width: 38.47,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.70125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.9250000000001,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Iroquois\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.16,
    y: 0,
    width: 40.84,
    height: 29.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.70125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.5799999999999,
    y: 14.805,
    fontFamily: "Arial"
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 29.61,
    width: 39.24,
    height: 31.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 45.45,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 61.29,
    width: 39.24,
    height: 33.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 78.06,
    fontFamily: "Arial"
  }, "\n        Christian\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 94.83,
    width: 39.24,
    height: 33.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.313333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 111.8,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 128.76,
    width: 39.24,
    height: 34.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 146.01999999999998,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 163.28,
    width: 39.24,
    height: 35.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 181.05,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 198.82,
    width: 39.24,
    height: 36.02,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.002222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 216.82999999999998,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 234.84,
    width: 39.24,
    height: 36.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.013333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 252.88,
    fontFamily: "Arial"
  }, "\n        Bureau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 270.92,
    width: 39.24,
    height: 36.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.021666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 288.985,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 307.06,
    width: 39.24,
    height: 38.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 326.335,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 345.6,
    width: 39.24,
    height: 39.42,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 365.31,
    fontFamily: "Arial"
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 385.03,
    width: 39.24,
    height: 39.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.605714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 404.86499999999995,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 424.7,
    width: 39.24,
    height: 43.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 446.585,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 468.47,
    width: 39.24,
    height: 44.36,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.905
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 490.65000000000003,
    fontFamily: "Arial"
  }, "\n        Woodford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 512.83,
    width: 39.24,
    height: 45.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 535.6450000000001,
    fontFamily: "Arial"
  }, "\n        Stephenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 558.46,
    width: 39.24,
    height: 46.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.848000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 581.855,
    fontFamily: "Arial"
  }, "\n        Coles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 605.24,
    width: 39.24,
    height: 46.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.605714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 628.67,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.77,
    y: 652.1,
    width: 39.24,
    height: 47.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.39,
    y: 676.0500000000001,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 29.61,
    width: 60.78,
    height: 32.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.4,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Macoupin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.79,
    y: 29.61,
    width: 63.2,
    height: 32.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.39000000000001,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Boone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.99,
    y: 29.61,
    width: 64.86,
    height: 32.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.42000000000002,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.85,
    y: 29.61,
    width: 66.47,
    height: 32.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.085,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Ogle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.32,
    y: 29.61,
    width: 67.53,
    height: 32.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.085,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Grundy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.85,
    y: 29.61,
    width: 69.26,
    height: 32.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.566666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 415.48,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Whiteside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450.12,
    y: 29.61,
    width: 79.91,
    height: 32.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.566666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.075,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Vermilion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.03,
    y: 29.61,
    width: 84.83,
    height: 32.1,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.4449999999999,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.86,
    y: 29.61,
    width: 85.14,
    height: 32.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.4300000000001,
    y: 45.66,
    fontFamily: "Arial"
  }, "\n        Williamson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 61.71,
    width: 72.71,
    height: 53.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.901666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 88.41499999999999,
    fontFamily: "Arial"
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 115.12,
    width: 72.71,
    height: 55.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.032
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 142.7,
    fontFamily: "Arial"
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 170.28,
    width: 72.71,
    height: 55.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 198.15,
    fontFamily: "Arial"
  }, "\n        Kankakee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 226.02,
    width: 72.71,
    height: 59.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.551428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 255.95000000000002,
    fontFamily: "Arial"
  }, "\n        LaSalle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 285.88,
    width: 72.71,
    height: 71.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 321.605,
    fontFamily: "Arial"
  }, "\n        Kendall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 357.34,
    width: 72.71,
    height: 74.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.609999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 394.625,
    fontFamily: "Arial"
  }, "\n        Rock_Island\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 431.9,
    width: 72.71,
    height: 77.13,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.08875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 470.465,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 509.03,
    width: 72.71,
    height: 93.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.118333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 555.925,
    fontFamily: "Arial"
  }, "\n        Peoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.01,
    y: 602.82,
    width: 72.71,
    height: 97.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.118333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.365,
    y: 651.4100000000001,
    fontFamily: "Arial"
  }, "\n        McLean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 61.71,
    width: 71.52,
    height: 107.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.946666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.48,
    y: 115.68,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.24,
    y: 61.71,
    width: 78.82,
    height: 107.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.65,
    y: 115.68,
    fontFamily: "Arial"
  }, "\n        Sangamon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.05,
    y: 61.71,
    width: 96.09,
    height: 107.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.676666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.095,
    y: 115.68,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.14,
    y: 61.71,
    width: 96.38,
    height: 107.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.708888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.33,
    y: 115.68,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.52,
    y: 61.71,
    width: 103.18,
    height: 107.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.11,
    y: 115.68,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.7,
    y: 61.71,
    width: 123.3,
    height: 107.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.35,
    y: 115.68,
    fontFamily: "Arial"
  }, "\n        McHenry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 169.65,
    width: 139.52,
    height: 134.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.48000000000002,
    y: 237.135,
    fontFamily: "Arial"
  }, "\n        Kane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 304.61,
    width: 139.52,
    height: 194.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.48000000000002,
    y: 401.865,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.72,
    y: 499.12,
    width: 139.52,
    height: 200.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.48000000000002,
    y: 599.56,
    fontFamily: "Arial"
  }, "\n        Will\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.24,
    y: 169.65,
    width: 429.76,
    height: 91.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.278333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.12,
    y: 215.485,
    fontFamily: "Arial"
  }, "\n        DuPage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.24,
    y: 261.31,
    width: 429.76,
    height: 438.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 107.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.12,
    y: 480.655,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2020);
export default __webpack_public_path__ + "static/media/2020.4e1e5151fb6101374131f5f4a4089ec0.svg";
export { ForwardRef as ReactComponent };